import { cn } from "@/lib/utils";
import { Info, AlertTriangle, CheckCircle, AlertOctagon } from "lucide-react";

type AlertStatus = "info" | "warning" | "success" | "error";

type AlertProps = {
  status?: AlertStatus;
  children: React.ReactNode;
  className?: string;
};

const statusConfig: Record<AlertStatus, { icon: React.ElementType; className: string }> = {
  info: { icon: Info, className: "bg-blue-50 text-blue-800 border-blue-200" },
  warning: { icon: AlertTriangle, className: "bg-yellow-50 text-yellow-800 border-yellow-200" },
  success: { icon: CheckCircle, className: "bg-green-50 text-green-800 border-green-200" },
  error: { icon: AlertOctagon, className: "bg-red-50 text-red-800 border-red-200" },
};

export const Alert = ({ status = "info", children, className }: AlertProps) => {
  const config = statusConfig[status];
  const Icon = config.icon;

  return (
    <div className={cn("flex items-start gap-3 rounded-md border px-4 py-3", config.className, className)}>
      <Icon className="mt-0.5 size-5 shrink-0" />
      <div className="flex-1">{children}</div>
    </div>
  );
};
